import { StateCreator } from 'zustand';

interface GivebutterPlusState {
    hasDismissedGivebutterPlusFreeTrialDialog: boolean;
    hasDismissedTrialEndedDialog: boolean;
    freeTrialDialogMap: { [accountId: string]: { free_trial_dialog_last_seen: string | null } };
    setHasDismissedGivebutterPlusFreeTrialDialog: (hasDismissed: boolean) => void;
    setHasDismissedTrialEndedDialog: (hasDismissed: boolean) => void;
    setFreeTrialDialogLastSeen: (accountId: string, lastSeen: string | null) => void;
}

const createGivebutterPlusSlice: StateCreator<
    any,
    [['zustand/persist', unknown]],
    [],
    GivebutterPlusState
> = set => ({
    hasDismissedGivebutterPlusFreeTrialDialog: false,
    hasDismissedTrialEndedDialog: false,
    freeTrialDialogMap: {},
    setHasDismissedGivebutterPlusFreeTrialDialog: hasDismissedGivebutterPlusFreeTrialDialog =>
        set({ hasDismissedGivebutterPlusFreeTrialDialog }),

    setHasDismissedTrialEndedDialog: hasDismissedTrialEndedDialog =>
        set({ hasDismissedTrialEndedDialog }),

    setFreeTrialDialogLastSeen: (accountId, lastSeen) =>
        set((state: { freeTrialDialogMap: GivebutterPlusState['freeTrialDialogMap'] }) => ({
            freeTrialDialogMap: {
                ...state.freeTrialDialogMap,
                [accountId]: { free_trial_dialog_last_seen: lastSeen },
            },
        })),
});

export { createGivebutterPlusSlice };
export type { GivebutterPlusState };
